import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ZagIcon } from '@zag/ui';

/**
 * @deprecated Channel configuration is now handled per-channel
 * (e.g. webhook event types are configured on each webhook endpoint).
 * This component is retained only to avoid breaking existing template references.
 * It will be removed in a future cleanup.
 */
@Component({
  selector: 'zag-channel-config',
  imports: [TranslatePipe, ZagIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './channel-config.component.html',
  styleUrls: ['./channel-config.component.scss'],
})
export class ChannelConfigComponent {
  readonly isLoading = signal(false);
  readonly isSaving = signal(false);
  readonly saveSuccess = signal(false);
  readonly saveError = signal(false);
  readonly isDirty = signal(false);

  readonly matrix = signal<Record<string, Record<string, boolean>>>({});
  readonly eventTypes: string[] = [];
  readonly channels: string[] = [];

  isEnabled(_eventType: string, _channel: string): boolean {
    return false;
  }

  toggleConfig(_eventType: string, _channel: string): void {
    // no-op — deprecated
  }

  saveConfigs(): void {
    // no-op — deprecated
  }
}
